export default __webpack_public_path__ + "static/media/click.0d212a79.mp3";